export default {"src":"/_next/static/media/Icon4.c75ccd21.svg","height":51,"width":50};